import { Database } from "lucide-react";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { useDatasetExplorerStore } from "../datasetExplorerStore";
import ChatInput from "./ChatInput";

/**
 * Chat-first landing view for the Dataset Explorer.
 * Shows a text input so users can describe what data they want in natural language,
 * with an option to switch to the manual query builder.
 */
export default function DatasetChatView() {
  const askQuestion = useDatasetExplorerStore((s) => s.askQuestion);
  const chatLoading = useDatasetExplorerStore((s) => s.chatLoading);
  const chatError = useDatasetExplorerStore((s) => s.chatError);
  const setMode = useDatasetExplorerStore((s) => s.setMode);

  return (
    <div className="flex flex-col items-center justify-center h-full px-4">
      <div className="w-full max-w-2xl space-y-8">
        <div className="text-center space-y-2">
          <div className="mx-auto rounded-full bg-muted p-3 w-fit">
            <Database className="h-6 w-6 text-muted-foreground" />
          </div>
          <h2 className="text-lg font-semibold tracking-tight">
            What data would you like to explore?
          </h2>
          <p className="text-sm text-muted-foreground">
            Ask a question in plain English and we'll build the query for you.
          </p>
        </div>

        {chatError && (
          <Alert variant="destructive">
            <AlertDescription>{chatError}</AlertDescription>
          </Alert>
        )}

        <ChatInput
          onSubmit={askQuestion}
          disabled={chatLoading}
          loading={chatLoading}
        />

        <div className="text-center">
          <Button
            variant="link"
            className="text-xs text-muted-foreground"
            onClick={() => setMode("explorer")}
            disabled={chatLoading}
          >
            or build a query manually
          </Button>
        </div>
      </div>
    </div>
  );
}
